export default __webpack_public_path__ + "media/fonts/hps-euro-w01-bold-woff.woff2";